<template>
    <div class="ly-c-container">
        <div class="ly-c-container-row" v-if="$slots.header">
            <slot name="header"></slot>
        </div>
        <div class="ly-c-container-main" v-if="!$slots.left && !$slots.right">
            <slot></slot>
        </div>
        <div class="ly-c-container-v" v-if="$slots.left || $slots.right">
            <div class="ly-c-container-col" :style="leftStyle" v-if="$slots.left">
                <slot name="left"></slot>
            </div>
            <div class="ly-c-container-main">
                <slot></slot>
            </div>
            <div class="ly-c-container-col" :style="rightStyle" v-if="$slots.right">
                <slot name="right"></slot>
            </div>
        </div>
        <div class="ly-c-container-row" v-if="$slots.foot">
            <slot name="foot"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "Container",
    props: {
        leftWidth: { type: String, default: "" },
        rightWidth: { type: String, default: "" },
    },
    computed: {
        leftStyle() {
            return this.leftWidth ? { width: this.leftWidth } : {};
        },
        rightStyle() {
            return this.rightWidth ? { width: this.rightWidth } : {};
        },
    },
};
</script>
